<template>
  <div>
    <div class="pa-tb-30">
      <div class="flex f-center f-between ma-b-40 content" v-for="(item, index) in dataList" :key="index">
        <div class="img">
          <img class="width100 height100 b-r-50 c-p head-portrait" :src="item.Image" @click="toDetail(item.Id)" />
          <img src="../../img/authentication.png" class="head-portrait-icon" alt="" srcset="">
        </div>
        <div class="boxs flex flex-direction f-around">
          <div class="flex f-center">
            <div class="fon-24 c-000 bold c-p" @click="toDetail(item.Id)">
              {{ item.Name }}
            </div>
            <div class="fon-16 c-fff tips flex f-center f-jcenter ma-lr-30">
              {{ item.Type }}
            </div>
            <div class="fon-24 c-000">{{ item.Title }}</div>
          </div>
          <div class="fon-18 t-omit-2 c-p" @click="toDetail(item.Id)">
            {{ item.Summary }}
          </div>
          <div class="flex f-center f-between">
            <div class="flex f-center f-wrap width70 tips-box">
              <div class="ma-r-20 fon-16 tips2 flex f-center f-jcenter ma-b-10" v-for="(items, indx) in item.Labels" :key="indx">
                {{ items }}
              </div>
            </div>
            <div class="flex f-center c-666 fon-16">
              <div>文章：{{item.Count}}</div>
              <div class="ma-l-40">人气：{{ item.Popularity }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dataList.length == 0" class="width100 pa-t-100">
      <Empty></Empty>
    </div>

    <div class="flex f-jcenter pa-b-20">
      <el-pagination @current-change="handleCurrentChange" :hide-on-single-page="true"
        :current-page.sync="queryList.pageIndex" :page-size="queryList.pageSize" layout="prev, pager, next, jumper"
        :total="totals"></el-pagination>
    </div>
  </div>
</template>

<script>
import { getExpertList } from "../../api.js";
var _this;
export default {
  name: "expertColumn",
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      tabsName: '1',
      queryList: {
        name: "",
        pageIndex: 1,
        pageSize: 10,
      },
      dataList: [],
      totals: 0,
      
    };
  },
  created() {
    _this = this;
    _this.queryList.name = _this.name
    _this.loadDataList();
  },
  methods: {
    //点击切换种类
    handleClick(tab) {
      console.log(tab);
      this.pageIndex = 1;
      this.sortType = 0;
      this.loadDataList();
    },
    //根据关键字搜索
    loadDataSearch(name) {
      _this.queryList.name = name
      _this.loadDataList()
    },
    //获取列表数据
    loadDataList() {
      getExpertList(this.queryList).then((res) => {
        this.dataList = res.data.Data.List;
        //更新页码
        this.totals = res.data.Data.TotalCount;
      });
    },
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.queryList.pageIndex = e;
      this.loadDataList();
    },
    //跳转专家详情
    toDetail(id) {
      this.$router.push({
        path: "/expertDetail",
        query: { id: id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-box{
    overflow: hidden;
    height: 80px;
}
.expert-column {
  .swiper {
    width: 100%;
    height: 314px;
    background-image: url(../../img/ExpertColumn.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;

    .toptexts {
      width: 736px;
      position: absolute;
      top: 28%;
      margin: 0 auto;
      left: 50%;
      margin-left: -368px;
      font-size: 20px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

      color: #fff;
      opacity: 0.75;
      text-align: center;

      .texts {
        line-height: 30px;
        letter-spacing: 3px;
        font-size: 16px;
      }

      .imgtitle {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
      }
    }
  }

  .content {
    position: relative;
    height: 240px;
  }
  .head-portrait{
    position:absolute;
    z-index: 1;
  }
   .head-portrait-icon{
    position:absolute;
    z-index: 2;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 180px;
   }
  .img {
    overflow: hidden;
    width: 205px;
    height: 205px;
    box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.568);
    border: 3px solid #fff;
    border-radius: 205px;
    background: transparent;
    z-index: 1;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
  }

  .boxs {
    width:86%;
    height: 300px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px 60px 20px 100px;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -10px;
    background-image: url('../../../src/img/showBg.png');
    background-size: 100% 100%;
    .tips {
      background: #eb6100;
      border-radius: 10px;
      width: 90px;
      min-height: 30px;
    }

    .tips2 {
      background: #bfbfbf;
      min-height: 30px;
      padding: 0 10px;
      border-radius: 10px;
    }
  }

  .search-box {
    position: relative;

    .search {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      background: #eeeeee;
      border-radius: 33px;
      width: 280px;

      .el-input {
        border-radius: 33px;

        .el-input__inner {
          border-radius: 33px;
          background: #eeeeee;
          border: none !important;
        }
      }

      .search-btn {
        background: #00479d;
        border-radius: 0px 33px 33px 0px;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        width: 100px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
